import { useState, FC } from 'react';
import { ChakraConfirmationDialog } from 'app/components/Dialogs';
import { Audio } from 'types/audio';

interface MarkPrivateAudioDialogProps {
  onClose: () => void;
  audio?: Audio;
  onConfirm: (audio: Audio) => Promise<void>;
}

export const MarkPrivateAudioDialog: FC<MarkPrivateAudioDialogProps> = ({
  onClose,
  onConfirm,
  audio,
}) => {
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    if (audio) {
      try {
        setLoading(true);
        await onConfirm(audio);
        onClose();
      } catch (e) {
        // proceed regardless
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <ChakraConfirmationDialog
      title="Mark audio file as latest version"
      handleAction={onSubmit}
      isOpen={Boolean(audio)}
      disableSubmitAction={loading}
      onClose={onClose}
      actionButtonText="Mark"
      message={`By marking audio file "${audio?.title}" as latest version, you will also make it accessible to other Collaborators.`}
    />
  );
};
